import Vue from 'vue'
import './index.styl'
import vueCustomElement from 'vue-custom-element'
import axios from '@wc/axios'
import { Message } from 'element-ui'
import SsCustomHeader from '@/components/SsCustomHeader'
import SsCustomFooter from '@/components/SsCustomFooter'
import SsCustomerService from '@/components/SsCustomerService'
import { formatImage } from '@/utils/formatImage'
import { openLink, testLink, formatDate } from '@/utils'

Vue.use(vueCustomElement)
Vue.customElement('ss-custom-footer', SsCustomFooter)
Vue.customElement('ss-customer-service', SsCustomerService)

Vue.prototype.$http = axios

Vue.prototype.$round = (number, precision, type = 'string') => {
  const count = Math.round(+number + 'e' + precision) / Math.pow(10, precision)
  if (type === 'number') {
    return count
  }
  return count.toFixed(precision)
}

Vue.prototype.$toast = (options) => {
  options = options || {}
  if (typeof options === 'string') {
    options = {
      message: options
    }
  }
  options.customClass = 'ss__toast'
  options.iconClass = `ssCommunityIcon__${options.type || 'info'}`
  return Message(options)
}

Vue.prototype.$openLink = openLink
Vue.prototype.$testLink = testLink
Vue.prototype.$app = {
  // 默认图片
  imgSrc: 'https://cdn-static.sspai.com/ui/img-placeholder.png',
  avatarSrc: 'https://cdn-static.sspai.com/ui/otter_avatar_placeholder_240511.png',
  imgErrorSrc: 'https://cdn-static.sspai.com/ui/error_placeholder.jpeg'
}

Vue.filter('formatDate', formatDate)

function removeCookie (name, domain) {
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
  const path = 'path=/'
  const cookie = `${name}=; ${path}; ${expires}`

  document.cookie = cookie

  if (domain) {
    document.cookie = `${cookie}; domain=${domain}`
  }
}

const SsCustomHeaderWebComponent = {
  name: 'SsCustomHeaderWebComponent',

  data () {
    return {
      isLogin: false,
      userInfo: null,
      noticeCount: null
    }
  },

  methods: {
    handleLogin () {
      window.sessionStorage.setItem(
        'referer',
        window.location.pathname + window.location.search
      )
      this.$openLink('/login', '_self')
    },
    handleLogout () {
      window.localStorage.removeItem('ssToken')
      removeCookie('sspai_jwt_token')
      removeCookie('sspai_jwt_token', 'sspai.com')
      removeCookie('sspai_jwt_token', '.sspai.com')
      removeCookie('sspai_cross_token')
      removeCookie('sspai_cross_token', 'sspai.com')
      removeCookie('sspai_cross_token', '.sspai.com')
      document.cookie = 'sspai_cross_token=' + encodeURIComponent('logout') + '; path=/; domain=.sspai.com'
      window.location.reload()
    }
  },

  async beforeMount () {
    const ssToken = localStorage.getItem('ssToken')
    if (ssToken) {
      try {
        const res = await this.$http('/user/info/get')
        if (res.error === 3004) {
          this.handleLogout()
          return
        }
        if (res.error) {
          throw new Error(res.msg)
        }
        this.isLogin = true
        this.userInfo = res.data
        const noticeCountRes = await this.$http('/information/user/unread/count/info/get')
        if (noticeCountRes.error === 3004) {
          this.handleLogout()
          return
        }
        if (noticeCountRes.error) {
          throw new Error(noticeCountRes.msg)
        }
        this.noticeCount = noticeCountRes.data
      } catch (error) {
        console.log(error)
        if (error.response?.status === 401 || error.status === 401) {
          this.handleLogout()
          return
        }
        this.isLogin = false
        this.userInfo = null
        this.noticeCount = null
      }
    }
  },

  render (h) {
    return h(SsCustomHeader, {
      props: {
        isLogin: this.isLogin,
        userInfo: this.userInfo,
        noticeCount: this.noticeCount,
        whitelist: []
      },
      on: {
        login: this.handleLogin,
        logout: this.handleLogout
      }
    })
  }
}

Vue.customElement('ss-custom-header', SsCustomHeaderWebComponent)

function ssCustomHeaderDarkModeChange () {
  let darkMode = 0
  if (navigator.cookieEnabled) {
    darkMode = window.localStorage.getItem('darkMode') ? parseInt(window.localStorage.getItem('darkMode')) : 0
  }
  const matchMedia = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  if ((!darkMode && matchMedia) || darkMode === 2) {
    document.documentElement.classList.add('theme-dark')
  } else {
    document.documentElement.classList.remove('theme-dark')
  }
}

const hasWindow = typeof window !== 'undefined'
hasWindow && (window.isSupportWebp = (function () {
  const elem = document.createElement('canvas')
  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  return false
})())
hasWindow && (window.__CDN_HOST__ = window.location.origin === 'https://sspai.com' ? 'https://cdnfile.sspai.com/' : 'https://test-images.sspai.com/')
hasWindow && ssCustomHeaderDarkModeChange()
hasWindow && window.addEventListener('ssCustomHeaderDarkModeChange', ssCustomHeaderDarkModeChange)

Vue.prototype.$formatImageSrc = formatImage.bind(
  null,
  window.isSupportWebp,
  window.__CDN_HOST__
)
